"use client";
import React from "react";
import "@/styles/emblaShopSlider.css";
import "@/styles/emblaArticleSlider.css";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import Link from "@/components/Link";
import { InnerBannerBox } from "@dxp-feed/ui/InnerBannerBox";
import { SiteContainer } from "@/components/Container";
import { ResponsiveImage } from "@/components/Common/ResponsiveImage";
import { AemHost } from "@/utils/constant";
import { RenderHTML } from "@/helpers/ServerFuncytions";

const BannerBelow = ({ props }: any) => {
  const currentImage = ResponsiveImage({
    mobileImage: props?.mobileimage,
    tabletImage: props?.tabletimage,
    src: props?.image,
    imagePath: props?.image,
  });
  return (
    <SiteContainer className="w-full  pb-6 lgs:pb-8">
      <Box
        className={`flex flex-col flex-wrap overflow-hidden rounded-xl lg:rounded-3xl lg:flex-nowrap xl:max-w-[1536px]  mx-auto [&>div>div>div]:mb-0 [&>div]:w-full [&>div]:lg:p-0  [&>div]:p-0 
      ${props?.layout === "leftimage" ? "flex-row" : "[&>div>div>div]:flex-row-reverse [&>div>div>div]:flex-wrap xl:[&>div>div>div>div:first-child]:!min-h-[240px] [&>div>div>div>div:first-child]:!min-h-min [&>div>div>div]:lg:flex-nowrap"}`}
        style={
          props?.contentBgImage
            ? {
                backgroundImage: `url(${AemHost + props?.contentBgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }
            : {
                backgroundColor: props?.themeBgColor,
              }
        }
      >
        <InnerBannerBox
          imageUrl={currentImage}
          altText={props?.imagealt}
          className="max-w-[100%]"
          contentClassName="md:w-full !p-6 md:!p-8 lg:!p-[60px] lg:w-[50%] min-h-min bg-transparent"
          imgClassName="md:w-full md:!min-h-[350px] lg:order-0 lg:w-[50%]"
        >
          <Box as="div" className="flex flex-col gap-2 md:gap-4 px-3">
            <Text
              as="h3"
              className="text-brandBlack  text-2xl xs:text-3xl xl:text-4xl 2xl:text-5xl font-raleway"
            >
              {props?.title}
            </Text>
            {props?.description && (
              <Box
                as="div"
                className="flex flex-col 2xs:flex-row items-center gap-4"
              >
                <Text className="font-normal  text-base sm:text-body lgs:text-base text-brandBlack">
                  {RenderHTML(props?.description)}
                </Text>
              </Box>
            )}

            {props?.linktitle && (
              <Link
                href={props?.link || "#"}
                target={props?.linktarget || "_self"}
                aria-label={props?.linkAreaLabel}
                className={`font-body !text-base w-full 2xs:w-auto max-w-max text-brandBlack flex gap-2 ${props?.description && "mt-3 md:mt-2"}`}
              >
                <Text
                  as="span"
                  className="font-bold text-base text-brandSecondary"
                >
                  {props?.linktitle}
                </Text>
                <Text
                  as="span"
                  className="icon icon-right-arrow text-brandSecondary"
                ></Text>
              </Link>
            )}
          </Box>
        </InnerBannerBox>
      </Box>
    </SiteContainer>
  );
};

export default BannerBelow;
